import EditRoom from './EditRoom.vue';
export default EditRoom;
